import { BaseImagePointContainer } from 'common/styles/globalStyles';
import styled from 'styled-components';

export const DataCenterContainer = styled(BaseImagePointContainer)``;
